import { createRequestActions } from '../utils';
import * as functionTypes from './functionTypes';

export const listFunctions = createRequestActions(functionTypes.FUNCTION_LIST);
